const blogsData = [
  {
    title: "Best Oligospermia Treatment in Jabalpur",
    description:
      "Find the best oligospermia treatment in Jabalpur with expert care. Consult Dr. Archana Shrivastava for advanced infertility solutions to improve sperm health.",
    link: "/Best-Oligospermia-Treatment-in-Jabalpur",
    image: require("../../AdminDashBoard/blog3.jpg"),
  },
  {
    title: "Best Infertility Doctors for Male in Jabalpur",
    description:
      "Discover the best male infertility treatment in Jabalpur. Consult Dr. Archana Shrivastava for advanced testing, effective treatments, and personalized care.",
    link: "/Best-Male-Infertility-Treatment-in-Jabalpur",
    image: require("../../AdminDashBoard/blog11.jpg"),
  },
  {
    title: "Best Infertility Treatment Doctor in Jabalpur",
    description:
      "Find the best infertility treatment doctors in Jabalpur. Consult Dr. Archana Shrivastava for expert solutions in IVF, male, female, and unexplained infertility.",
    link: "/Best-Infertility-Treatment-Doctor-in-Jabalpur",
    image: require("../../AdminDashBoard/blog13.jpeg"),
  },
  {
    title: "Infertility Treatment Doctor In Jabalpur",
    description:
      "Pluro Jabalpur Fertility Center, the best fertility clinic in Jabalpur, provides comprehensive IVF and infertility treatments. Book a consultation with a top specialist today!",
    link: "/Infertility-Treatment-Doctor-Jabalpur",
    image: require("../../AdminDashBoard/blog9.png"),
  },
  {
    title: "Best IVF Doctor in Jabalpur - Dr. Archana Shrivastava",
    description:
      "Looking for the best IVF doctor in Jabalpur? Discover how Dr. Archana Shrivastava and Pluro Jabalpur Fertility Centre provide compassionate care, advanced treatments, and high success rates to fulfill your dream of parenthood.",
    link: "/Best-IVF-Doctor-in-Jabalpur-Dr.Archana-Shrivastav",
    image: require("../../AdminDashBoard/blog3.jpg"),
  },
  {
    title:
      "Dr. Archana Shrivastava - Best IVF Doctor in Jabalpur, Madhya Pradesh",
    description:
      "Looking for the best IVF specialist in Jabalpur? At Pluro Jabalpur Fertility Center, Dr. Archana Shrivastava offers advanced fertility treatments, including IVF, ICSI, and IUI. Book a consultation today!",
    link: "/Dr.Archana-Shrivastav-Best-IVF-Doctor-in-Jabalpur-Madhya-Pradesh",
    image: require("../../AdminDashBoard/blog3.jpg"),
  },
  {
    title:
      "Best Infertility Doctor in Jabalpur | Dr. Archana Shrivastava Pluro Jabalpur Fertility Centre",
    description:
      "Consult Dr. Archana Shrivastava, the best infertility doctor in Jabalpur, at Pluro Jabalpur Fertility Centre. Get expert fertility treatments, including IVF, IUI, and male infertility solutions. Book your appointment today!",
    link: "/Best-Infertility-Doctor-in-Jabalpur-Dr.Archana-Shrivastav-Jabalpur-Fertility-Centre",
    image: require("../../AdminDashBoard/blog5.jpg"),
  },
  {
    title:
      "Difference Between IVF and IUI Treatments : Best IVF Doctor in Jabalpur",
    description:
      "Learn the key differences between IVF and IUI treatments, their success rates, procedures, and when to choose each. Expert insights from the best IVF doctor in Jabalpur.",
    link: "/Difference-Between-IVF-and-IUI-Treatments-Best-IVF-Doctor-in-Jabalpur",
    image: require("../../AdminDashBoard/blog6.jpg"),
  },
  {
    title:
      "Struggling with Infertility? Meet the Best IUI Center and best infertility doctors in Jabalpur",
    description:
      "Discover expert infertility care at the best IUI center in Jabalpur. Consult top infertility doctors in Jabalpur for personalized treatment and a successful pregnancy journey.",
    link: "/Struggling-with-Infertility-Meet-the-Best-IUI-Center-and-best-infertility-doctors-in-Jabalpur",
    image: require("../../AdminDashBoard/blog8.jpg"),
  },
  {
    title:
      "Egg Freezing in Jabalpur – Best Fertility Treatment | Pluro Jabalpur IVF Center",
    description:
      "Get advanced egg freezing in Jabalpur at Pluro Jabalpur IVF Center. Preserve your fertility with expert care from Dr. Archana Shrivastava. Book a consultation today!",
    link: "/Egg-Freezing-in-Jabalpur-Best-Fertility-Treatment",
    image: require("../../AdminDashBoard/blog7.jpg"),
  },
  {
    title:
      "Best IVF Doctor in Jabalpur | Infertility Specialist Dr. Archana Shrivastava",
    description:
      "Looking for the best IVF doctor in Jabalpur? Meet Dr. Archana Shrivastava at Pluro Jabalpur Fertility Center, a leading infertility specialist offering advanced fertility treatments like IVF, IUI, ICSI, and more. Book your consultation today.",
    link: "/Meet-the-Best-IVF-Doctor-and-Infertility-Specialist-in-Jabalpur",
    image: require("../../AdminDashBoard/blog9.png"),
  },
  {
    title: "IVF Treatment in Jabalpur | Cost, Success Rates & Best IVF Clinic",
    description:
      "Looking for the best IVF clinic in Jabalpur? Get expert fertility care at Pluro Jabalpur IVF Centre with affordable IVF costs, high success rates, and advanced treatments. Book your consultation now!",
    link: "/IVF-Treatment-in-Jabalpur-Cost-Success-Rates-Best-Fertility-Clinic",
    image: require("../../AdminDashBoard/blog10.jpg"),
  },
  {
    title:
      "Best Gynecologist and Obstetrician in Jabalpur – Dr. Archana Shrivastavaa",
    description:
      "Explore the best gynecologist and obstetrician in Jabalpur at Pluro Jabalpur Fertility Centre. Consult Dr. Archana Shrivastavaa for expert women's health and fertility care.",
    link: "/best-gynecologist-obstetrician-jabalpur",
    image: require("../../AdminDashBoard/blog12.jpg"),
  },
  {
    title:
      "Best Treatment for Oligospermia in Jabalpur – Pluro Jabalpur Fertility Centre",
    description:
      "Explore the best treatment for oligospermia in Jabalpur at Pluro Jabalpur Fertility Centre. Get expert care, advanced diagnosis, and effective solutions for male infertility",
    link: "/best-treatment-for-oligospermia",
    image: require("../../AdminDashBoard/blog12.jpg"),
  },
  {
    title:
      "Pluro Jabalpur IVF Center: Pioneering Advanced Fertility Solutions for Couples",
    description:
      "Explore advanced fertility solutions at Pluro Jabalpur IVF Center. We specialize in helping couples achieve their dreams of parenthood with expert care and technology.",
    link: "/best-fertility-clinic-jabalpur-ivf-treatment",
    image: require("../../AdminDashBoard/blog13.jpeg"),
  },
  {
    title: "Can’t Conceive Naturally? IVF and ICSI Might Be the Key",
    description:
      "Explore advanced fertility solutions at Pluro Jabalpur IVF Center. We specialize in helping couples achieve their dreams of parenthood with expert care and technology.",
    link: "/can-not-conceive-naturally-IVF-and-ICSI-Might-Be-the-Key",
    image: require("../../AdminDashBoard/blog14.png"),
  },
  {
    title: "Male Infertility Treatment in Jabalpur | Best Fertility Doctors",
    description:
      "Looking for the best male infertility treatment in Jabalpur? Meet top infertility doctors in Jabalpur for expert solutions. Book a consultation today.",
    link: "/Male-Infertility-Treatment-in-Jabalpur-Meet-the-Best-Doctors-for-Fertility-Solutions",
    image: require("../../AdminDashBoard/blog11.jpg"),
  },
].reverse().map(blog => ({
  ...blog,
  author: "Pluro Jabalpur Fertility Center",
}));

export default blogsData;
